export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_BY_ID: 'GET_BY_ID',
  UPDATE: 'UPDATE',
  UPDATE_LOGS: 'UPDATE_LOGS',
  UPDATE_STATUS: 'UPDATE_STATUS',
  GET_LIST_USERS: 'GET_LISTS_USERS',
  GET_LIST_BY_USER: 'GET_LIST_BY_USER',
  GET_LIST_BY_JOB: 'GET_LIST_BY_JOB',
  GET_HOLIDAY_LISTS: 'GET_HOLIDAY_LISTS',
  STOP_JOB: 'STOP_JOB',
  GET_SCHEDULE_JOB_LOG: 'GET_SCHEDULE_JOB_LOG',
  GET_SCHEDULE_PATIENT_LOG: 'GET_SCHEDULE_PATIENT_LOG',
}
